export default {
  name: 'KPI',
  computed: {
    valueFormatted () {
      // format the value with thousands separator (using ","), no decimals
      return this.value?.toLocaleString('en-US', { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits })
    },
    isLoading () {
      return this.loading || this.value === null || this.value === undefined
    }
  },
  props: {
    name: String,
    value: Number,
    valueChange: Number,
    tooltip: String,
    loading: Boolean,
    large: Boolean,
    digits: {
      type: Number,
      default: 0
    },
    suffix: {
      type: String,
      default: ''
    }
  }
}
